/**
 * A faixa de título que abre cada aba do SM.
 *
 * Papel: reproduz `.card-title` (l. 141–152) — fundo `--superficie-2`, Outfit
 * 15 px 400, borda sem a de baixo e cantos de cima arredondados, encostada na
 * barra de filtros que vem logo depois.
 *
 * Como usar: o texto entra já em maiúsculas, como a origem o escreve; a faixa
 * não tem `text-transform`. Os dois espaços de cada lado do ponto são
 * não separáveis (`  ·  `), e espaço comum ali seria
 * colapsado pelo navegador num espaço só.
 */
import { type ReactNode } from 'react';

/**
 * A faixa de título.
 *
 * @param children - O texto da faixa, em maiúsculas.
 * @returns A faixa.
 */
export function FaixaDoCartao({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-t-[6px] border border-b-0 border-emb-borda bg-superficie-2 px-[18px] py-3 font-outfit text-[15px] font-normal tracking-normal text-foreground">
      {children}
    </div>
  );
}
